import React, { useEffect, useMemo, useState } from "react";
import { ChevronLeft, ChevronRight, CalendarRange } from "lucide-react";
import api from "@/lib/api";
import { PageHeader, EmptyState, Loader, StatusBadge } from "@/components/dashboard/ui";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";

function weekStart(d) { const x = new Date(d); const day = (x.getDay() + 6) % 7; x.setDate(x.getDate() - day); x.setHours(0, 0, 0, 0); return x; }

export default function AdminPlanning() {
  const [missions, setMissions] = useState(null);
  const [staff, setStaff] = useState([]);
  const [start, setStart] = useState(() => weekStart(new Date()));
  const [filterStaff, setFilterStaff] = useState("all");

  useEffect(() => {
    api.get("/missions").then(({ data }) => setMissions(data || []));
    api.get("/users?role=secretary").then(({ data }) => setStaff(data || [])).catch(() => {});
  }, []);

  const days = useMemo(() => Array.from({ length: 7 }, (_, i) => { const d = new Date(start); d.setDate(d.getDate() + i); return d; }), [start]);
  if (missions === null) return <Loader />;

  const visible = missions.filter((m) => m.status !== "Annulée" && (filterStaff === "all" || m.staff_id === filterStaff));
  const move = (dir) => setStart((s) => { const x = new Date(s); x.setDate(x.getDate() + dir * 7); return x; });

  return (
    <div>
      <PageHeader title="Planning équipe" subtitle="Vue hebdomadaire des missions par jour."
        action={
          <div className="flex items-center gap-2">
            <Select value={filterStaff} onValueChange={setFilterStaff}><SelectTrigger className="w-48"><SelectValue /></SelectTrigger>
              <SelectContent><SelectItem value="all">Tous les membres</SelectItem>{staff.map((s) => <SelectItem key={s.user_id} value={s.user_id}>{s.name}</SelectItem>)}</SelectContent></Select>
            <div className="flex gap-1"><button onClick={() => move(-1)} className="h-9 w-9 rounded-md border border-slate-200 flex items-center justify-center hover:bg-slate-50"><ChevronLeft className="h-4 w-4" /></button><button onClick={() => move(1)} className="h-9 w-9 rounded-md border border-slate-200 flex items-center justify-center hover:bg-slate-50"><ChevronRight className="h-4 w-4" /></button></div>
          </div>
        } />
      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-7 gap-3">
        {days.map((d) => {
          const iso = d.toISOString().slice(0, 10);
          const dayMissions = visible.filter((m) => m.date === iso);
          const isToday = iso === new Date().toISOString().slice(0, 10);
          return (
            <div key={iso} className={`bg-white rounded-xl border p-3 min-h-[140px] ${isToday ? "border-primary ring-1 ring-primary/20" : "border-slate-200"}`} data-testid={`plan-day-${iso}`}>
              <p className="text-xs font-semibold text-slate-400 uppercase">{d.toLocaleDateString("fr-CH", { weekday: "short" })}</p>
              <p className="text-lg font-bold text-slate-900 font-mono-metric">{d.getDate()}</p>
              <div className="mt-2 space-y-1.5">
                {dayMissions.length === 0 ? <p className="text-xs text-slate-300">—</p> : dayMissions.map((m) => (
                  <div key={m.mission_id} className="rounded-md bg-primary/5 border border-primary/10 p-1.5">
                    <p className="text-xs font-medium text-slate-800 leading-tight">{m.start}–{m.end}</p>
                    <p className="text-[11px] text-slate-500 truncate">{m.staff_name}</p>
                    <p className="text-[11px] text-slate-400 truncate">{m.client_name}</p>
                  </div>
                ))}
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
}
